import { render, staticRenderFns } from "./UpdateAbsent.vue?vue&type=template&id=24b76d00&"
import script from "./UpdateAbsent.vue?vue&type=script&lang=js&"
export * from "./UpdateAbsent.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAbsent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports